const SMARTLING_MAIN_PAGE = "https://www.smartling.com";

export function redirectToMainPage() {
    window.location.href = SMARTLING_MAIN_PAGE;
}
